import { FC, ReactElement } from 'react'
import classnames from 'classnames'

import { Button } from '@/components/@buttons/Button/Button'
import { Icon, IconName } from '@/components/Icon/Icon'

import './ReactionButton.scss'

interface ReactionButtonProps {
    count: number
    icon: IconName
    label: string
    pressed: boolean
    onClick: () => void
    className?: string
    iconClassName?: string
}

export const ReactionButton: FC<ReactionButtonProps> = ({
    count,
    icon,
    label,
    pressed,
    onClick,
    className = '',
    iconClassName = '',
}): ReactElement => (
    <Button
        type="button"
        text={label}
        aria-label={label}
        aria-pressed={pressed}
        className={classnames('reaction-button', { 'reaction-button--pressed': pressed }, className)}
        onClick={onClick}
    >
        <Icon name={icon} className={`reaction-button__icon ${iconClassName}`} />
        {count > 0 && <span className="reaction-button__count">{count}</span>}
    </Button>
)
